import { Reducer } from 'redux';
import { Manufacturer } from "models/Manufacturer";
import { IManufacturerActions, ManufacturerActionType } from "redux/actions/settings/ManufacturerActions";

const initialState: Manufacturer[] | null = null;
export const manufacturersReducer: Reducer<Manufacturer[] | null, IManufacturerActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case ManufacturerActionType.FETCH_MANUFACTURERS_SUCCESS:
                {
                    return action.returnPayload as Manufacturer[];
                }
            case ManufacturerActionType.ADD_MANUFACTURER_SUCCESS:
                {
                    let newManufs = [...state!];
                    newManufs.push({ ...action.returnPayload } as Manufacturer)
                    return newManufs;
                }
            case ManufacturerActionType.EDIT_MANUFACTURER_SUCCESS:
            case ManufacturerActionType.DELETE_MANUFACTURER_SUCCESS:
                {
                    let newManufs = [...state!];
                    const updatedManuf = { ...action.returnPayload } as Manufacturer;
                    newManufs = newManufs.map(nm => nm.id === updatedManuf.id ? updatedManuf : nm);
                    return newManufs;
                }
            default:
                return state;
        }
    };
